import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import Email from 'GlobalStores/Email'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import StoreUser from 'GlobalStores/User/StoreUser'
import { get } from 'lodash'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import HttpHelper from 'Services/HttpHelper'
import { PaymentAPIs } from './PaymentServices/PaymentAPI'
import StoreCheckout from './StoreCheckout'
import storeCheckout from './StoreCheckout'
import { PathHelper } from 'GlobalStores/Cores/Helpers/PathHelper'
import storeAuth from 'GlobalStores/User/StoreAuth'
import storeUser from 'GlobalStores/User/StoreUser'
import storeCredit from 'GlobalStores/StoreCredit'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

const HYDRA_URL = /localhost/.test(window.location.href) ? 'https://hydra.unicity.net/v5a' : 'https://hydra.unicity.net/v5a'

class Payment {
    uuid = ''
    products = null
    detailPage = null

    hydra = null
    hydraOrderAndSubscribe = null
    lambda = null
    paymentId = null
    ushop = null
    email = null

    autoship = null

    newBaId = ''

    PaymentStep = null

    orderDataToUrl = ''
    enrollId = ''

    errors = null

    emailConfigs = {
        from: 'Unicity <no-reply@unicity.com>',
        subject: 'Order confirmation',
        subjectAutoship: 'Autoship confirmation',
        emailTemplate: 'u22_general_shopping',
        AUS: {
            emailTemplate: 'feelgreat_email_aus',
            emailAutoshipTemplate: 'feelgreat_email_autoship_aus',
            csEmail: /localhost/.test(window.location.href) ? 'khanitnan.jansit@unicity.com' : 'cs.aus@unicity.com',
            templateData: {},
            languages: []
        },
        SGP: {
            emailTemplate: 'feelgreat_email_aus',
            emailAutoshipTemplate: 'feelgreat_email_autoship_aus',
            csEmail: /localhost/.test(window.location.href) ? 'khanitnan.jansit@unicity.com' : 'contact.sg@unicity.com',
            templateData: {},
            languages: []
        },
        MYS: {
            emailTemplate: 'feelgreat_email_aus',
            emailAutoshipTemplate: 'feelgreat_email_autoship_aus',
            csEmail: /localhost/.test(window.location.href) ? 'khanitnan.jansit@unicity.com' : 'malaysia.customerservice@unicity.com',
            templateData: {},
            languages: []
        },
        templateAutoshipData: {
            autoshipNumber: '',
            shipToName: '',
            orderDate: '',
            startMonth: '',
            shipToAddress: '',
            phone: '',
            items: []
        }
    }

    smsConfigs = {
        AUS: {
            code: '61[phone]',
            text: `Your Unicity Order #[order_id] - AUD[price] has been processed. To check on the status, log in or email us at ${this.emailConfigs.AUS.csEmail}`
        },
        SGP: {
            code: '65[phone]',
            text: `Your Unicity Order #[order_id] - SGD[price] has been processed. To check on the status, log in or email us at ${this.emailConfigs.SGP.csEmail}`
        },
        MYS: {
            code: '60[phone]',
            text: `Your Unicity Order #[order_id] - MYR[price] has been processed. To check on the status, log in or email us at ${this.emailConfigs.MYS.csEmail}`
        }
    }

    orderData = null

    GetPaymentId() {
        return this.paymentId
    }

    async PreparePaymentData() {
        try {
            const response = await PaymentAPIs.CreatePaymentData(this.uuid, StoreCountry.Country3(), StoreCheckout.creditCardAlias)
            sessionStorage.setItem('paymentID', response.data.payment_id)
            this.hydra = response.data.hydra
            this.hydraOrderAndSubscribe = response.data.hydraOrderAndSubscribe
            this.paymentId = response.data.payment_id
            this.ushop = response.data.ushop
            this.email = response.data.email

            if (response.data.autoship) {
                this.autoship = response.data.autoship
            }

            StorePaymentStep.SetPaymentStep('payment', 1)

            return { success: true, data: response }
        } catch (error) {
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }

            if (get(error, 'response.data.error.message', null)) {
                if (get(error, 'response.data.errorMessageIsDictionary')) {
                    responseError = <T>{responseError}</T>
                } else {
                    responseError += `[${get(error, 'response.data.error.referenceNo', '')}]`
                }
            }

            if (get(error, 'response.data.error.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.error.message', '')}]`
            }

            if (get(error, 'response.data.error.error.orderValidate.success_order_validate') === false) {
                const errorLimitPurchaseHydra = error.response.data.error.error.orderValidate.message
                const errorArray = responseError ? [responseError, errorLimitPurchaseHydra] : [errorLimitPurchaseHydra]

                StorePaymentStep.SetErrors(errorArray)
            } else {
                StorePaymentStep.SetErrors([responseError])
            }

            console.log('error', responseError)
            StorePaymentStep.SetPaymentStep('payment', -1)
            throw error
        }
    }

    async PreparePaymentLambdaData() {
        try {
            const response = await PaymentAPIs.CreatePaymentLambdaData(this.uuid)
            this.hydra = response.data.hydra

            this.orderData = {
                ...response.data.hydra,
                id: {
                    unicity: ''
                },
                customer: {
                    id: {
                        unicity: StoreAuth.GetId()
                    }
                }
            }
            this.lambda = {
                uuid: this.uuid,
                type: 'feelGreat',
                source_path: window.location.href,
                ba_id: StoreAuth.GetId(),
                token: StoreAuth.GetToken(),
                gateway_success_url: 'www.google.com',
                gateway_error_url: 'www.google.com',
                gateway_name: 'a',
                payments: []
            }
            this.ushop = response.data.data
            this.email = response.data.email
            if (response.data.autoship) {
                this.autoship = response.data.autoship
            }

            StorePaymentStep.SetPaymentStep('payment', 1)

            return { success: true, data: response }
        } catch (error) {
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }
            if (get(error, 'response.data.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.message', '')}]`
            }

            if (get(error, 'response.data.error.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.error.message', '')}]`
            }

            StorePaymentStep.SetErrors([responseError])
            StorePaymentStep.SetPaymentStep('payment', -1)
            throw error
        }
    }

    async PostToLambda() {
        console.info('Posting to Lambda')
        let response = null
        try {
            let dataToLambda = toJS(this.lambda)
            const paymentData = get(this.hydra, 'transactions.items[0]')
            const eCreditData = get(this.hydra, 'transactions.items[1]')

            const paymentArray = []
            if (get(eCreditData, 'amount') > 0 && get(eCreditData, 'amount') < get(this.ushop, 'total_price')) {
                paymentArray.push({
                    ...get(paymentData, 'methodDetails', {}),
                    method: get(paymentData, 'method', '').replace('CreditCard', 'creditCard'),
                    amount: get(this.ushop, 'total_price') - get(eCreditData, 'amount')
                })
                paymentArray.push({
                    ...get(eCreditData, 'methodDetails', {}),
                    method: get(eCreditData, 'method', '').replace('StoreCredit', 'eCredit'),
                    amount: get(eCreditData, 'amount')
                })
            } else if (get(eCreditData, 'amount') === get(this.ushop, 'total_price')) {
                paymentArray.push({
                    ...get(eCreditData, 'methodDetails', {}),
                    method: get(eCreditData, 'method', '').replace('StoreCredit', 'eCredit'),
                    amount: get(eCreditData, 'amount')
                })
            } else {
                paymentArray.push({
                    ...get(paymentData, 'methodDetails', {}),
                    method: get(paymentData, 'method', '').replace('CreditCard', 'creditCard'),
                    amount: get(this.ushop, 'total_price')
                })
            }

            dataToLambda = {
                ...dataToLambda,
                payments: paymentArray
            }
            response = await PaymentAPIs.CreateLambdaOrder(dataToLambda, StoreAuth.GetToken())

            if (!response.data.success) {
                StorePaymentStep.SetPaymentStep('createOrder', -1)
                let responseError = [`${get(response.data, 'response_desc', '')}`]
                StorePaymentStep.SetErrors([responseError])
                return response
            }

            this.paymentId = get(response.data, 'payment_id', '')

            this.orderData = { ...this.orderData, ...response.data }
            StorePaymentStep.SetPaymentStep('createOrder', 1)

            if (get(this.orderData, 'customer.autoorders.items[0]', null)) {
                this.autoshipNumber = get(this.orderData, 'customer.autoorders.items[0].id.unicity', null)
            }

            return response
        } catch (error) {
            const errorMessageIsDictionary = get(error, 'response.data.errorMessageIsDictionary', false)
            StorePaymentStep.SetPaymentStep('createOrder', -1)
            if (errorMessageIsDictionary) {
                let responseError = `${get(error, 'response.data.message', '')}`
                StorePaymentStep.SetErrors([responseError])
            } else {
                let responseError = `${get(error, 'message', '')}`
                if (get(error, 'response.data.error_message', null)) {
                    responseError += ` [${get(error, 'response.data.error_message', '')}]`
                }
                if (get(error, 'response.data.message', null)) {
                    responseError += ` [${get(error, 'response.data.message', '')}]`
                }
                StorePaymentStep.SetErrors([responseError])
            }
            throw error
        }
    }

    async PostToHydra(options) {
        console.info('Posting to Hydra')
        let response = null
        this.orderDataToUrl = `${HYDRA_URL}/customers/me/orders`
        try {
            const dataToHydra = toJS(this.hydra)
            response = await PaymentAPIs.CreateOrder(dataToHydra, StoreAuth.GetToken())

            if (response) {
                this.orderData = response.data
                this.orderDataHeader = response.headers
                this.orderDataCurl = response.request
                StorePaymentStep.SetPaymentStep('createOrder', 1)
                if (get(this.orderData, 'customer.autoorders.items[0]', null)) {
                    this.autoshipNumber = get(this.orderData, 'customer.autoorders.items[0].id.unicity', null)
                }
            }
        } catch (error) {
            StorePaymentStep.SetPaymentStep('createOrder', -1)
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }
            if (get(error, 'response.data.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.message', '')}]`
            }
            this.errors = JSON.stringify(get(error, 'response.data', ''))
            runInAction(() => {
                StorePaymentStep.SetErrors([responseError])
                storeCheckout.SetErrors([responseError])
                this.orderDataHeader = get(error, 'response.headers', '')
            })
            throw error
        }
    }

    async PostToHydraWithCreateAutoShip() {
        console.info('Posting to Hydra')
        let response = null
        this.orderDataToUrl = `${HYDRA_URL}/customers/me/ordersAndSubscriptions?async=false`
        try {
            const dataToHydraAndSubscribe = toJS(this.hydraOrderAndSubscribe)
            const transactions = toJS(this.hydra.transactions)

            const dataToCreateOrderAndSubscriptions = {
                ...dataToHydraAndSubscribe,
                transactions: { ...transactions },
            }

            response = await PaymentAPIs.CreateOrderAndSubscriptions(dataToCreateOrderAndSubscriptions, StoreAuth.GetToken())

            if (response) {
                this.orderData = response.data?.data?.order
                this.orderDataHeader = response.headers
                this.orderDataCurl = response.request
                StorePaymentStep.SetPaymentStep('createOrder', 1)

                this.autoshipNumber = response.data.data?.autoOrder?.id?.unicity
            }
        } catch (error) {
            StorePaymentStep.SetPaymentStep('createOrder', -1)
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }
            if (get(error, 'response.data.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.message', '')}]`
            }
            this.errors = JSON.stringify(get(error, 'response.data', ''))
            StorePaymentStep.SetErrors([responseError])
            this.orderDataHeader = get(error, 'response.headers', '')
            throw error
        }
    }

    async PostToHydraWorldPayNON3DsWithCreateAutoShip() {
        console.info('Posting to Hydra WorldPay NON 3Ds with subscription')
        let response = null
        this.orderDataToUrl = `${HYDRA_URL}/customers/me/ordersAndSubscriptions?async=false`
        try {
            const dataToHydraAndSubscribe = toJS(this.hydraOrderAndSubscribe)
            const transactions = toJS(this.hydra.transactions)

            const dataToCreateOrderAndSubscriptions = {
                ...dataToHydraAndSubscribe,
                transactions: { ...transactions },
            }

            response = await PaymentAPIs.CreateOrderAndSubscriptions(dataToCreateOrderAndSubscriptions, StoreAuth.GetToken())

            if (response) {
                this.orderData = response.data?.data?.order
                this.orderDataHeader = response.headers
                this.orderDataCurl = response.request
                StorePaymentStep.SetPaymentStep('createOrder', 1)

                this.autoshipNumber = response.data?.data?.autoOrder?.id?.unicity
                StorePaymentStep.SetPaymentStep('autoship', this.autoshipNumber ? 1 : -2)
            }
        } catch (error) {
            StorePaymentStep.SetPaymentStep('createOrder', -1)
            StorePaymentStep.SetPaymentStep('autoship', -1)
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }
            if (get(error, 'response.data.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.message', '')}]`
            }
            StorePaymentStep.SetErrors([responseError])
            this.errors = JSON.stringify(get(error, 'response.data', ''))
            this.orderDataHeader = get(error, 'response.headers', '')
            throw error
        }
    }

    async PostToHydraWorldPayNON3Ds(options) {
        console.info('Posting to Hydra WorldPay NON 3Ds')
        let response = null
        this.orderDataToUrl = `${HYDRA_URL}/customers/me/orders`

        try {
            const dataToHydra = toJS(this.hydra)
            response = await PaymentAPIs.CreateOrder(dataToHydra, StoreAuth.GetToken())

            if (response) {
                this.orderData = response.data
                this.orderDataHeader = response.headers
                this.orderDataCurl = response.request
                StorePaymentStep.SetPaymentStep('createOrder', 1)
            }
        } catch (error) {
            StorePaymentStep.SetPaymentStep('createOrder', -1)
            let responseError = `${get(error, 'message', '')}`
            if (get(error, 'response.data.error.error_message', null)) {
                responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
            }
            if (get(error, 'response.data.error.message', null)) {
                responseError += ` [${get(error, 'response.data.error.message', '')}]`
            }
            StorePaymentStep.SetErrors([responseError])
            this.errors = JSON.stringify(get(error, 'response.data', ''))
            this.orderDataHeader = get(error, 'response.headers', '')
            throw error
        }
    }

    SendEmail() {
        try {
            const sendEmail = new Email()

            const fullNameEnglish = StoreUser.CustomerData().GetNativeName(this.orderData.shipToName, 'fullName')
            const fullNameNative = StoreUser.CustomerData().GetNativeName(this.orderData.shipToName, 'nativeName', false)

            const isUseBothOfFullName = fullNameEnglish.replace(/ /g).toLowerCase().trim() !== fullNameNative.replace(/ /g).toLowerCase().trim()
            const shipToName = `${fullNameEnglish}${isUseBothOfFullName ? ` ,${fullNameNative}` : ''}`

            sendEmail
                .SetToEmail(this.orderData.shipToEmail)
                .SetOrderId(this.orderData.id.unicity)
                .SetMemberId(this.orderData.customer.id.unicity)
                .SetShipTo(shipToName, this.ushop.display_address)
                .SetProductItems(this.email.products_email)
                .SetShippingType('delivery')

            if (this.autoship) {
                sendEmail.SetAutoship(this.autoshipNumber)
            }

            if (StoreUser.CustomerData().ProfilePicture()) {
                sendEmail.SetProfilePicture(StoreUser.CustomerData().ProfilePicture('original'))
            }
            sendEmail.Send()
        } catch (error) {
            console.error('SEND EMAIL ERROR', error)
        }
    }

    SendEmailV4() {
        try {
            const sendEmail = new Email()

            const fullNameEnglish = StoreUser.CustomerData().GetNativeName(this.orderData.shipToName, 'fullName')
            const fullNameNative = StoreUser.CustomerData().GetNativeName(this.orderData.shipToName, 'nativeName', false)

            const isUseBothOfFullName = fullNameEnglish.replace(/ /g).toLowerCase().trim() !== fullNameNative.replace(/ /g).toLowerCase().trim()

            const shipToName = `${fullNameEnglish}${isUseBothOfFullName ? ` ,${fullNameNative}` : ''}`

            sendEmail
                .SetToEmail(this.orderData.shipToEmail)
                .SetOrderId(this.orderData.id.unicity)
                .SetMemberId(this.orderData.customer.id.unicity)
                .SetShipTo(shipToName, this.ushop.display_address)
                .SetProductItems(this.email.products_email)
                .SetShippingType('delivery')
                .SetTotalPrice(this.orderData.terms.total)

            if (this.autoship && ['AUS'].includes(StoreCountry.Country3())) {
                sendEmail.SetAutoship(this.autoshipNumber)
            }

            if (StoreUser.CustomerData().ProfilePicture()) {
                sendEmail.SetProfilePicture(StoreUser.CustomerData().ProfilePicture('original'))
            }

            sendEmail.SendV4()
        } catch (error) {
            console.error('SEND EMAIL ERROR', error)
        }
    }

    SendSms() {
        console.info('Sending SMS')
        try {
            const phone = get(this.orderData, 'shipToPhone')
            const formatphone = ['AUS', 'NZL', 'MYS'].includes(StoreCountry.Country3()) ? phone.slice(1) : phone
            const dataSms = {
                to: this.smsConfigs[StoreCountry.Country3()].code.replace('[phone]', formatphone),
                text: this.smsConfigs[StoreCountry.Country3()].text
                    .replace('[order_id]', get(this.orderData, 'id.unicity'))
                    .replace('[price]', get(this.orderData, 'terms.total') || get(this.ushop, 'total_price'))
                    .replace('[pv]', get(this.orderData, 'terms.pv') || get(this.ushop, 'total_pv'))
            }
            PaymentAPIs.PostSms(dataSms)
        } catch (error) {
            console.warn('send sms warning', error)
        }
    }

    async UpdateToLog(transaction = null, isCreateSubscribe = 0, isFailed = false, debug, omitPaymentStatus = false) {
        const resolvedPaymentId = this.paymentId || sessionStorage.getItem('paymentID') || ''
        try {
            let orderData = toJS(this.orderData) || {}
            let marskedCreditCard = toJS(this.hydra) || {}

            const usedEcredit = storeCredit.ProductCreditUsed()
            const totalPrice = get(this.ushop, 'total_price', 0)
            const usedCreditAmount = get(usedEcredit, 'amount', 0)

            let logTransaction = transaction
                ? (Array.isArray(transaction) ? transaction : transaction.items || [])
                : get(orderData, 'transactions.items', [])
            if (logTransaction.length === 0 && usedCreditAmount > 0) {
                logTransaction = [usedEcredit]
            }

            marskedCreditCard.transactions = {
                items: logTransaction
            }

            if (marskedCreditCard.customer && marskedCreditCard.customer.autoorders) {
                if (marskedCreditCard.customer.autoorders.items[0]) {
                    marskedCreditCard.customer.autoorders.items = marskedCreditCard.transactions.items
                }
            }

            const postData = {
                payments_id: resolvedPaymentId,
                payment_status: isFailed || !transaction ? 'fail' : 'success',
                order_number: get(this.orderData, 'id.unicity', ''),
                approval_code: get(this.orderData, 'transactions.items[0].authorization', ''),
                payment_method1: usedCreditAmount > 0 ? (Number(usedCreditAmount) - Number(totalPrice) === 0 ? '' : 'creditCard') : '',
                payment_amount1: usedCreditAmount > 0 ? (Number(usedCreditAmount) - Number(totalPrice) === 0 ? '' : Number(totalPrice) - Number(usedCreditAmount)) : '',
                payment_method2: usedCreditAmount > 0 ? 'ecredit' : '',
                payment_amount2: usedCreditAmount > 0 ? usedCreditAmount : '',
                hydra_curl: this.toCurl({ url: this.orderDataToUrl, dataRaw: JSON.stringify(marskedCreditCard) }),
                hydra_response_header: JSON.stringify(this.orderDataHeader || {}) || '',
                hydra_response_body: isFailed || !transaction ? (this.errors || '') : (JSON.stringify(orderData) || ''),
                ...(isCreateSubscribe === 1 && { autoship_id: this.autoshipNumber || '' })
            }

            if (omitPaymentStatus) {
                // 3DS challenge redirect — the success page reports the status via hydra-log-by-order
                delete postData.payment_status
            }

            if (!this.detailPage.isEnroll) {
                postData.dist_id = get(this.orderData, 'customer.id.unicity', storeAuth.GetId())
                postData.dist_status = get(this.orderData, 'customer.type', storeUser.GetBaStatus())
            } else {
                postData.enroll_new_id = get(this.orderData, 'customer.id.unicity', '')
            }

            await PaymentAPIs.UpdateLog(postData, isCreateSubscribe, StoreCountry.Country3())

            StorePaymentStep.SetPaymentStep('updateLog', 1)
        } catch (error) {
            console.error('UpdateToLog error', error)
            try {
                await PaymentAPIs.UpdateLog(
                    {
                        payments_id: resolvedPaymentId,
                        payment_status: 'fail',
                        hydra_response_body: JSON.stringify({ updateLogError: error?.message || 'unknown error' })
                    },
                    isCreateSubscribe,
                    StoreCountry.Country3()
                )
            } catch (fallbackError) {
                console.error('UpdateToLog fallback error', fallbackError)
            }
            StorePaymentStep.SetPaymentStep('updateLog', -1)
        }
    }

    async UpdatePayMobLog(payment_status = 'waiting', payment_method) {
        console.info('Updating PayMob Log')
        try {
            let orderData = toJS(this.orderData)
            let hydraData = toJS(this.hydra)

            const postData = {
                payments_id: this.paymentId || sessionStorage.getItem('paymentID') || '',
                payment_status: payment_status,
                order_number: get(this.orderData, 'id.unicity', ''),
                approval_code: '',
                payment_method1: payment_method,
                payment_amount1: 'this.terms.total',
                payment_method2: '',
                payment_amount2: '',
                hydra_curl: this.toCurl({ url: this.orderDataToUrl, dataRaw: JSON.stringify(hydraData) }),
                hydra_response_header: JSON.stringify(this.orderDataHeader),
                hydra_response_body: JSON.stringify(orderData)
            }

            if (!this.detailPage.isEnroll) {
                postData.dist_id = get(this.orderData, 'customer.id.unicity', '')
                postData.dist_status = get(this.orderData, 'customer.type', '')
            } else {
                postData.enroll_new_id = get(this.orderData, 'customer.id.unicity', '')
            }

            await PaymentAPIs.UpdateLog(postData)
            StorePaymentStep.SetPaymentStep('updateLog', 1)
        } catch (error) {
            StorePaymentStep.SetPaymentStep('updateLog', -1)
            throw error
        }
    }

    async UpdateCMILog(payment_status = 'waiting', payment_method) {
        console.info('Updating CMI Log')
        try {
            let orderData = toJS(this.orderData)
            let hydraData = toJS(this.hydra)

            const postData = {
                payments_id: this.paymentId || sessionStorage.getItem('paymentID') || '',
                payment_status: orderData.transactions.items[0] ? 'success' : 'failed',
                order_number: get(this.orderData, 'id.unicity', ''),
                approval_code: get(this.orderData, 'transactions.items[0].id.teller', ''),
                payment_method1: payment_method,
                payment_amount1: 'this.terms.total',
                payment_method2: '',
                payment_amount2: '',
                hydra_curl: this.toCurl({ url: this.orderDataToUrl, dataRaw: JSON.stringify(hydraData) }),
                hydra_response_header: JSON.stringify(this.orderDataHeader),
                hydra_response_body: JSON.stringify(orderData)
            }

            if (!this.detailPage.isEnroll) {
                postData.dist_id = get(this.orderData, 'customer.id.unicity', '')
                postData.dist_status = get(this.orderData, 'customer.type', '')
            } else {
                postData.enroll_new_id = get(this.orderData, 'customer.id.unicity', '')
            }

            await PaymentAPIs.UpdateLog(postData)
            StorePaymentStep.SetPaymentStep('updateLog', 1)
        } catch (error) {
            StorePaymentStep.SetPaymentStep('updateLog', -1)
            throw error
        }
    }

    async UpdateMepsLog(payment_status = 'waiting', payment_method) {
        console.info('Updating MEPS Log')
        try {
            let orderData = toJS(this.orderData)
            let hydraData = toJS(this.hydra)

            const postData = {
                payments_id: this.paymentId || sessionStorage.getItem('paymentID') || '',
                payment_status: orderData.transactions.items[0] ? 'success' : 'failed',
                order_number: get(this.orderData, 'id.unicity', ''),
                approval_code: get(this.orderData, 'transactions.items[0].id.teller', ''),
                payment_method1: payment_method,
                payment_amount1: 'this.terms.total',
                payment_method2: '',
                payment_amount2: '',
                hydra_curl: this.toCurl({ url: this.orderDataToUrl, dataRaw: JSON.stringify(hydraData) }),
                hydra_response_header: JSON.stringify(this.orderDataHeader),
                hydra_response_body: JSON.stringify(orderData)
            }

            if (!this.detailPage.isEnroll) {
                postData.dist_id = get(this.orderData, 'customer.id.unicity', '')
                postData.dist_status = get(this.orderData, 'customer.type', '')
            } else {
                postData.enroll_new_id = get(this.orderData, 'customer.id.unicity', '')
            }

            await PaymentAPIs.UpdateLog(postData)
            StorePaymentStep.SetPaymentStep('updateLog', 1)
        } catch (error) {
            StorePaymentStep.SetPaymentStep('updateLog', -1)
            throw error
        }
    }

    toCurl = ({
        method = `POST`,
        url,
        headers = {
            'Content-Type': `application/json`
        },
        dataRaw
    }) => {
        const curlLines = [`curl --location --request ${method} '${HttpHelper.Proxy({ originalUrl: url })}'`, ...Object.keys(headers).map(key => `--header '${key}: ${headers[key]}'`), `--data-raw '${dataRaw}'`]

        return curlLines.join(` `)
    }

    SubmitOneTimePayment = async ({ payments = null, type = '' }) => {
        storeCheckout.paymentErrors = []
        const hostname = window.location.origin
        const postbackUrl = {
            success: `{{hostname}}/{{country}}/payment-response/success`,
            error: `{{hostname}}/{{country}}/payment-response/failed`
        }
        const successUrl = postbackUrl.success.replace('{{hostname}}', hostname).replace('{{country}}', StoreCountry.CountryLowerCase())
        const errorUrl = postbackUrl.error.replace('{{hostname}}', hostname).replace('{{country}}', StoreCountry.CountryLowerCase())

        const query = new URLSearchParams(document.location.search)

        const ENV_DEV = /fg-dev/.test(window.location.href)

        const data = {
            uuid: query.get('uuid'),
            gateway_success_url: ENV_DEV ? PathHelper.getPostBackUrlDEV(StoreCountry.CountryLowerCase()).success : successUrl,
            gateway_error_url: ENV_DEV ? PathHelper.getPostBackUrlDEV(StoreCountry.CountryLowerCase()).error : errorUrl,
            source_path: window.location.href,
            type: 'feelGreat'
        }

        if (StoreAuth.isAuthorized) {
            data.ba_id = StoreAuth.GetId()
            data.token = StoreAuth.GetToken()
        } else {
            data['order_type'] = 'enroll'
        }
        if (payments) {
            data['payments'] = payments
        }

        if (type === 'qr') {
            data['gateway_name'] = '2c2p'
        }

        try {
            const is3ds = ['THA'].includes(StoreCountry.Country3())
            const result = await PaymentAPIs.CreatePaymentDataForHostedGateway(data, is3ds)

            if (result.data.success === false) {
                let errors = []

                if (result.data.gateway_name === '2c2p') {
                    let error = result.data.error
                    let responseError = `${get(error, 'message', '')}`
                    const referenceNo = get(result, 'data.referenceNo', null)

                    errors.push(responseError)
                    errors.push(`${referenceNo}`)

                    storeCheckout.SetErrors(errors)
                } else {
                    let error = result.data.error
                    let responseError = `${get(error, 'message', '')}`
                    if (get(error, 'response.data.error.error_message', null)) {
                        responseError += ` [${get(error, 'response.data.error.error_message', '')}]`
                    }
                    if (get(error, 'response.data.error.message', null)) {
                        responseError += ` [${get(error, 'response.data.error.message', '')}]`
                    }
                    errors.push(responseError)
                    storeCheckout.SetErrors(errors)
                }
            } else {
                if (is3ds && result.data.isRedirect) {
                    window.location.href = result.data.redirectUrl
                } else {
                    return result.data
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    async PreparePostData(postData = null) {
        if (!postData) return false
        try {
            this.paymentId = postData.gateway_ref_id
            this.email = postData.formatData.email

            if (postData.formatData.autoship) {
                this.autoship = postData.formatData.autoship
            }
            return true
        } catch (error) {
            console.log(error)
        }
    }

    constructor(uuid, detailPage, paymentStep) {
        this.uuid = uuid
        this.detailPage = detailPage
        this.PaymentStep = paymentStep

        makeAutoObservable(this)
    }
}

export default Payment
